import { render, staticRenderFns } from "./PopUpModal.vue?vue&type=template&id=bf04ef2c&scoped=true"
import script from "./PopUpModal.vue?vue&type=script&lang=js"
export * from "./PopUpModal.vue?vue&type=script&lang=js"
import style0 from "./PopUpModal.vue?vue&type=style&index=0&id=bf04ef2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf04ef2c",
  null
  
)

export default component.exports